import type {SubgoalApiModel as Subgoal} from '@yourcoach/shared/api/goal';
import type {Expand} from '@yourcoach/shared/api/types';

export const expand: Expand = {
  goal: ['subgoal_ids'],
};

export type Expanded = {
  subgoals: Subgoal[];
};
